function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css, ThemeContext } from 'styled-components';
import { getLanguage } from './getLanguage';
import { AgroModal } from '../AgroModal';
import { Text } from '../../atoms/Text';
import { AgroLocation } from '../../atoms/AgroLocation';
import { AgroButton } from '../../atoms/AgroButton';
import { Column } from '../../atoms/Column';
import { Row } from '../../atoms/Row';
import { ImyLocation } from '../../atoms/AgroIcon/icons';
import { getAddressByCoordinates } from '../../services/userAddress';
function getWindowDimensions() {
  var _window = window,
    width = _window.innerWidth,
    height = _window.innerHeight;
  return {
    width: width,
    height: height
  };
}
export default function useWindowDimensions() {
  var _useState = useState(getWindowDimensions()),
    _useState2 = _slicedToArray(_useState, 2),
    windowDimensions = _useState2[0],
    setWindowDimensions = _useState2[1];
  useEffect(function () {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowDimensions.width < 768;
}
var AgroLocationWeatherModal = function AgroLocationWeatherModal(_ref) {
  var _ref$isUserLogged = _ref.isUserLogged,
    isUserLogged = _ref$isUserLogged === void 0 ? false : _ref$isUserLogged,
    onLogin = _ref.onLogin,
    onClose = _ref.onClose,
    onChangeLocation = _ref.onChangeLocation,
    _ref$country = _ref.country,
    country = _ref$country === void 0 ? 'AR' : _ref$country,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'es_AR' : _ref$language,
    apiGateway = _ref.apiGateway,
    tagManager = _ref.tagManager,
    _ref$ctaCurrentLocati = _ref.ctaCurrentLocationLabel,
    ctaCurrentLocationLabel = _ref$ctaCurrentLocati === void 0 ? null : _ref$ctaCurrentLocati;
  var theme = useContext(ThemeContext);
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    hasError = _useState6[0],
    setHasError = _useState6[1];
  var isMobile = useWindowDimensions();
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    validatedForm = _useState8[0],
    setValidatedForm = _useState8[1];
  var translations = getLanguage(country);
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    browserLocationError = _useState0[0],
    setBrowserLocationError = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    locationDeniedError = _useState10[0],
    setLocationDeniedError = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    location = _useState12[0],
    setLocation = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    loadingBrowserLocation = _useState14[0],
    setLoadingBrowserLocation = _useState14[1];
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  var validate = function validate(value) {
    return !(!value || Object.keys(value).length === 0);
  };
  var trackEvent = function trackEvent(dataLayer) {
    var gtmEvent = {
      dataLayer: dataLayer
    };
    if (tagManager) {
      tagManager(gtmEvent);
    }
  };
  var trackUserInteraction = function trackUserInteraction(item_id) {
    trackEvent({
      event: 'select_content',
      content_type: 'geolocation_modal',
      item_id: item_id
    });
  };
  var confirm = function confirm() {
    setValidatedForm(true);
    if (!hasError) {
      trackEvent({
        event: 'get_user_location',
        user_location_name: "".concat(value.City, ", ").concat(value.State, ", ").concat(value.Country)
      });
      onChangeLocation(value);
    }
  };
  var login = function login() {
    trackUserInteraction('click_login');
    onLogin();
  };
  var register = function register() {
    trackUserInteraction('click_register_location');
    window.location.href = country === 'AR' ? '/pronostico_clima_tiempo/7-dias' : '/previsao-clima-tempo/7-dias';
  };
  useEffect(function () {
    setHasError(!validate(value));
  }, [value]);
  useEffect(function () {
    if (!hasError && location) {
      confirm();
    }
  }, [hasError, location]);
  useEffect(function () {
    if (hasError && validatedForm) {
      trackEvent({
        event: 'field_errors',
        content_type: 'geolocation_modal',
        item_id: 'add_location'
      });
    }
  }, [hasError, validatedForm]);
  var closeModal = function closeModal() {
    trackUserInteraction('close');
    onClose();
  };
  var getLocation = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(coordinates) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setLoadingBrowserLocation(true);
            getAddressByCoordinates({
              apiGateway: apiGateway,
              latitude: coordinates.latitude,
              longitude: coordinates.longitude,
              country: country
            }).then(function (location) {
              setLocation(location);
              setLoadingBrowserLocation(false);
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getLocation(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onCurrentLocationClick = function onCurrentLocationClick() {
    trackUserInteraction('click_current_location');
    var prompt = false; // para trackeo de accion del usuario sobre el promt de permisos
    if ('permissions' in navigator) {
      //tracking ventana permisos del navegador nativa
      navigator.permissions.query({
        name: 'geolocation'
      }).then(function (result) {
        if (result.state === 'prompt') {
          prompt = true;
          trackEvent({
            event: 'modal_impression',
            modal_type: 'location_permissions_popover'
          });
        }
      });
    }
    window.navigator.geolocation.getCurrentPosition(function (position) {
      if (prompt) {
        trackEvent({
          event: 'select_content',
          content_type: 'location_permissions_popover',
          item_id: 'allow'
        });
      }
      getLocation(position.coords);
      setBrowserLocationError(null);
    }, function (err) {
      if (prompt) {
        trackEvent({
          event: 'select_content',
          content_type: 'location_permissions_popover',
          item_id: 'block'
        });
      }
      setBrowserLocationError(err);
    });
  };
  useEffect(function () {
    if (browserLocationError) {
      if (browserLocationError.code == 1) {
        //ubicacion denegada
        setLocationDeniedError(true);
        trackEvent({
          event: 'field_errors',
          content_type: 'geolocation_modal',
          item_id: 'no_location_permissions'
        });
      }
    } else {
      setLocationDeniedError(false);
    }
    if (location) {
      setValue(location);
    }
  }, [location, browserLocationError]);
  return /*#__PURE__*/React.createElement(AgroModal, {
    showCloseBtn: true,
    disablePageScroll: false,
    variant: "small",
    closeOnOutsideClick: false,
    onDismiss: function onDismiss() {
      return closeModal();
    }
  }, /*#__PURE__*/React.createElement(Title, {
    type: "heading-sm",
    color: theme.colors.black
  }, showTranslation('title')), /*#__PURE__*/React.createElement(ModalContainer, null, /*#__PURE__*/React.createElement(Subtitle, {
    type: "body-md",
    color: theme.colors.gray900
  }, isUserLogged ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: showTranslation('subtitle_logged')
    }
  }) : /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: showTranslation('subtitle')
    }
  })), /*#__PURE__*/React.createElement(LoginContainer, {
    isMobile: isMobile,
    "data-cy": "locationModal-loginSection"
  }, isUserLogged ? /*#__PURE__*/React.createElement(LoginButton, {
    variant: "secondary",
    fullWidth: isMobile,
    onClick: function onClick() {
      return register();
    }
  }, showTranslation('register_button')) : /*#__PURE__*/React.createElement(LoginButton, {
    variant: "secondary",
    fullWidth: isMobile,
    onClick: function onClick() {
      return login();
    }
  }, showTranslation('login_button'))), /*#__PURE__*/React.createElement(SeparatorContainer, null, /*#__PURE__*/React.createElement(SeparatorDiv, null, /*#__PURE__*/React.createElement(Separator, null)), /*#__PURE__*/React.createElement(Text, {
    type: "body-lg",
    px: "sm",
    color: theme.colors.gray800
  }, "O"), /*#__PURE__*/React.createElement(SeparatorDiv, null, /*#__PURE__*/React.createElement(Separator, null))), /*#__PURE__*/React.createElement(Subtitle, {
    type: "body-md",
    color: theme.colors.gray900
  }, showTranslation('subtitle_current_location')), /*#__PURE__*/React.createElement(AgroButton, {
    mt: isMobile ? 'md' : 'sm',
    variant: "outlineSecondary",
    fullWidth: true,
    withIcon: true,
    onClick: function onClick() {
      return onCurrentLocationClick();
    },
    loading: loadingBrowserLocation,
    style: {
      marginTop: '0'
    }
  }, /*#__PURE__*/React.createElement(ImyLocation, {
    fill: "gray800"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '4px'
    }
  }, ctaCurrentLocationLabel ? ctaCurrentLocationLabel : showTranslation('use_current_location'))), locationDeniedError && /*#__PURE__*/React.createElement(StyledError, null, showTranslation('location_denied_error'))));
};
AgroLocationWeatherModal.propTypes = {
  isUserLogged: PropTypes.bool,
  country: PropTypes.string,
  language: PropTypes.string,
  apiGateway: PropTypes.string.isRequired,
  onLogin: PropTypes.func,
  onClose: PropTypes.func,
  onChangeLocation: PropTypes.func,
  tagManager: PropTypes.func,
  showCTAUseCurrentLocation: PropTypes.bool,
  ctaCurrentLocationLabel: PropTypes.string
};
export { AgroLocationWeatherModal };
var ModalContainer = styled.div.withConfig({
  displayName: "AgroLocationWeatherModal__ModalContainer",
  componentId: "zrby7u-0"
})(["display:flex;flex-direction:column;position:relative;"]);
var Title = styled(Text).withConfig({
  displayName: "AgroLocationWeatherModal__Title",
  componentId: "zrby7u-1"
})(["padding-right:16px;"]);
var Subtitle = styled(Text).withConfig({
  displayName: "AgroLocationWeatherModal__Subtitle",
  componentId: "zrby7u-2"
})(["padding:16px 0;"]);
var LocationContainer = styled(Column).withConfig({
  displayName: "AgroLocationWeatherModal__LocationContainer",
  componentId: "zrby7u-3"
})(["align-items:center;"]);
var ConfirmButtonColumn = styled(Column).withConfig({
  displayName: "AgroLocationWeatherModal__ConfirmButtonColumn",
  componentId: "zrby7u-4"
})(["", ""], function (_ref3) {
  var isUserLogged = _ref3.isUserLogged;
  return isUserLogged && css(["text-align:-webkit-right;"]);
});
var AgroLocationInput = styled(AgroLocation).withConfig({
  displayName: "AgroLocationWeatherModal__AgroLocationInput",
  componentId: "zrby7u-5"
})(["width:100%;"]);
var ConfirmButton = styled(AgroButton).withConfig({
  displayName: "AgroLocationWeatherModal__ConfirmButton",
  componentId: "zrby7u-6"
})(["display:flex;align-self:flex-end;margin-top:16px;min-width:120px;@media (min-width:", "){margin-top:4px;margin-left:16px;align-self:flex-start;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint.md;
});
var SeparatorContainer = styled.div.withConfig({
  displayName: "AgroLocationWeatherModal__SeparatorContainer",
  componentId: "zrby7u-7"
})(["margin-top:16px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;"]);
var SeparatorDiv = styled.div.withConfig({
  displayName: "AgroLocationWeatherModal__SeparatorDiv",
  componentId: "zrby7u-8"
})(["width:100%;"]);
var Separator = styled.hr.withConfig({
  displayName: "AgroLocationWeatherModal__Separator",
  componentId: "zrby7u-9"
})(["border-width:1px;border:0;border-top:1px solid ", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray800;
});
var LoginContainer = styled.div.withConfig({
  displayName: "AgroLocationWeatherModal__LoginContainer",
  componentId: "zrby7u-10"
})(["display:flex;flex-direction:row;", ""], function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile && css(["flex-direction:column;"]);
});
var LoginTitle = styled(Text).withConfig({
  displayName: "AgroLocationWeatherModal__LoginTitle",
  componentId: "zrby7u-11"
})(["margin-top:16px;"]);
var LoginButton = styled(AgroButton).withConfig({
  displayName: "AgroLocationWeatherModal__LoginButton",
  componentId: "zrby7u-12"
})(["margin-top:0;min-width:132px;width:100%;"]);
var StyledError = styled.span.withConfig({
  displayName: "AgroLocationWeatherModal__StyledError",
  componentId: "zrby7u-13"
})(["color:", ";font-size:12px;line-height:18px;font-weight:400;letter-spacing:-0.1px;margin-top:4px;font-family:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.red500;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontFamily;
});